module.exports = __webpack_public_path__ + "img/ic_work_preference.4a4d9be5.svg";